import Image from "next/image"

import { cn } from "@/lib/utils"

// SVG flag for an ISO 3166-1 alpha-2 code, served from /flags (country-flag-icons,
// MIT). Emoji flags render as two plain letters on Windows, so never use them.
// Decorative: the country name always sits next to it.
export default function FlagIcon({
  iso2,
  className,
}: {
  iso2: string
  className?: string
}) {
  const code = iso2.toUpperCase()
  return (
    <Image
      src={`/flags/${code === "UK" ? "GB" : code}.svg`}
      alt=""
      aria-hidden
      width={18}
      height={12}
      // Lazy loading never fires inside a scrolling Select list, and each
      // flag is a few hundred bytes anyway.
      loading="eager"
      className={cn(
        "inline-block h-3 w-4.5 shrink-0 rounded-xs align-middle",
        className,
      )}
    />
  )
}
